import styled from 'styled-components'

export const ScanAddress = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
`

export const AddressView = styled.div`
  background: #1b77fd;
  width: ${({ size }) => (size ? `${size}px` : `55px`)};
  height: ${({ size }) => (size ? `${size}px` : `55px`)};
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const AddressKey = styled.p`
  all: unset;
  font-size: 12px;
  color: white;
  text-align: center;
  font-weight: bold;
`

export const AddressValue = styled.p`
  all: unset;
  font-size: 12px;
  color: white;
  text-align: center;
  font-weight: bold;
`
